/*
 *  (c) 2015 - 2021 ENISCO by FORCAM GmbH
 */
import {SvgIcon, SvgIconProps} from '@mui/material'
import React from 'react'

export function DeleteOpen(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox='0 0 24 24'>
      <path d='M0,0H24V24H0Z' fill='none' />
      <path d='M6,19a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V7H6ZM23.94,9,21.25,6.73l-.13-1.4-3.85-3.2-1.4.13L13.17,0,11.9,1.57l10.77,8.94Z' />
    </SvgIcon>
  )
}
